class ProductFormVariants extends HTMLElement {
  constructor() {
    super();

    const elements = {
      form: this.closest("form"),
      inputs: this.querySelectorAll("input[type='radio']")
    };

    elements.inputs.forEach((element) => {
      element.addEventListener("change", () => {
        const variant = get_variant();

        document.dispatchEvent(new CustomEvent("productformvariants:change", {
          detail: {
            variant: variant
          }
        }));

        Theme.URLParams.set("variant", variant.id);

        elements.form.querySelector("[name=id]").value = variant.id;

         if (variant && variant.id) {
          this.onVariantChange(variant.id);
        }
      });
    });

    function get_variant() {
      const variant_title = get_variant_title(elements.inputs);
      const variant = get_variant_by_title(variant_title);

      return variant;
    }

    function get_variant_title(form_elements) {
      return Array.from(form_elements)
        .filter(el => el.checked)
        .map(el => el.value)
        .join(" / ")
        .trim();
    }

    function get_variant_by_title(title) {
      let selected_variant = null;

      Theme.Liquid.product.variants.forEach((variant) => {
        if (title == variant.title) {
          selected_variant = variant;
        }
      });

      return selected_variant;
    }
  }
  onVariantChange(variantId) {
    const sectionWrapper = document.querySelector(".product-info");
    if (!sectionWrapper) return;
    const sectionId = sectionWrapper.dataset.sectionId;
    this.fetchSection(sectionId, variantId);
  }

  fetchSection(sectionId, variantId) {
    const url = `${window.location.pathname}?variant=${variantId}&section_id=${sectionId}`;
    fetch(url)
      .then(r => r.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const newSection = doc.querySelector(`.product-info[data-section-id='${sectionId}']`);
        const current = document.querySelector(`.product-info[data-section-id='${sectionId}']`);
        if (newSection && current) current.replaceWith(newSection);
      });
  }
}

customElements.define("product-form-variants", ProductFormVariants)